import styled from "styled-components";
import { StyledSectionTitle } from "../../dashboard/SectionTitle/index.styled";

export const StyledAnonymousQuestionsList = styled.div`
  width: 100%;
  margin-top: 20px;
  padding: 16px 18px 0;
  background-color: #ffffff;
  border-top-right-radius: 30px;
  border-top-left-radius: 30px;
  box-shadow: 0px -11px 29.9px 0px #7e8aad1a;
  box-sizing: border-box;

  .questions-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
  }

  .questions-header.has-questions {
    margin-bottom: 0;
  }

  .anonymous-title-icon {
    width: 28px;
    height: 28px;
    object-fit: contain;
    margin-inline-start: auto;
    border: 0.5px solid #7e8aad33;
    box-shadow: 0px 2px 3.9px 0px #1222433b;
    border-radius: 50%;
    padding: 4px;
    background-color: #ffffff;
    box-sizing: border-box;
  }

  ${StyledSectionTitle} {
    flex: 1;
    margin-bottom: 0;
  }

  .questions-subtitle {
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 10px;
    line-height: 10px;
    letter-spacing: -0.22px;
    text-align: right;
    color: #7e8aad;
    margin: 0 0 30px 0;
    padding: 0;
  }

  .questions-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0;
  }
  .questions-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 12px 0 4px;
  }

  .questions-empty-icon {
    width: auto;
    height: 80px;
    min-height: 140px;
    object-fit: contain;
  }

  .questions-empty-text {
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 400;
    font-size: 10px;
    line-height: 10px;
    letter-spacing: -0.22px;
    text-align: center;
    color: #7e8aad;
    margin: 0;
  }
`;
